import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
  PresenceDocument,
  PresenceSubscription,
  PresenceSubscriptionVariables
} from '../../generated/voice-presence-api/graphql';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PresenceGQL {
  constructor(private apollo: Apollo) {}

  subscribe(variables: PresenceSubscriptionVariables): Observable<any> {
    return this.apollo.use('presence').subscribe<PresenceSubscription>({
      query: PresenceDocument,
      variables,
    });
  }
}
